import React from 'react';
import { SmartToy as VaanikIcon } from '@mui/icons-material';
import { T, fontBody, fontDisplay } from '../../tokens';

export default function VaanikNodeEditor({ enabled, onToggle }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px',
        borderRadius: 10, background: enabled ? '#EFF6FF' : T.page,
        border: `1.5px solid ${enabled ? '#BFDBFE' : T.line}`,
      }}
      >
        <div style={{
          width: 36, height: 36, borderRadius: 9, flexShrink: 0,
          background: enabled ? '#DBEAFE' : T.lineSoft,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        >
          <VaanikIcon sx={{ fontSize: 18, color: enabled ? '#1D4ED8' : T.slateLight }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: fontDisplay, fontSize: 13.5, fontWeight: 600, color: T.ink }}>
            Vaanik Agent
          </div>
          <div style={{ fontFamily: fontBody, fontSize: 11.5, color: T.slate, marginTop: 2 }}>
            Hand off conversation to AI after auto-reply
          </div>
        </div>
        <button
          type="button"
          onClick={() => onToggle(!enabled)}
          style={{
            width: 40, height: 22, borderRadius: 999, border: 'none', cursor: 'pointer',
            background: enabled ? '#2563EB' : T.lineSoft,
            position: 'relative', transition: 'background 0.15s',
            flexShrink: 0,
          }}
          title={enabled ? 'Disable Vaanik Agent' : 'Enable Vaanik Agent'}
        >
          <span style={{
            position: 'absolute', top: 3, width: 16, height: 16, borderRadius: '50%',
            background: '#fff', transition: 'left 0.15s',
            left: enabled ? 21 : 3,
          }}
          />
        </button>
      </div>

      {enabled && (
        <div style={{
          padding: '10px 12px', borderRadius: 8,
          background: '#F0F9FF', border: '1px solid #BAE6FD',
          fontFamily: fontBody, fontSize: 11.5, color: '#0369A1', lineHeight: 1.5,
        }}
        >
          <strong>Active:</strong> After this automation sends its reply, Vaanik AI will take over
          the conversation and continue engaging the contact.
        </div>
      )}
    </div>
  );
}
